<template>
	<div class="entity-select-view">
		<div v-if="label" class="edit__label">{{ label }} <span v-if="!optional">*</span></div>
		<input :style="label ? { height: '30px' } : {}" :class="(_valid !== null ? (_valid ? 'validated' : 'validated error') : '')" ref="input" type="text" @click="focus" :value="value" @input="tap" />
	</div>
</template>

<script>
	import ContextPopupView from './ContextPopupView'
	import merge from '../functions/merge'

	export default {
		data() {
			return {
				results: [],
				timeout: null,
				str: ''
			};
		},
		props: {
			lazy: {
				type: Boolean,
				default: false
			},
			lbl: {
				type: [String, Number], 
				default: null
			},
			label: {
				type: String, 
				default: null
			},
			optional: {
				type: Boolean,
				default: false
			},
			validator: {
				type: Function,
				default: function (obj) {
					return null;
				}
			},
			create: {
				type: Function,
				default: null
			},
			labelMap: {
				type:  Function,
				default: function (obj) {
					
					return obj;
				}
			},
			descMap: {
				type:  Function,
				default: function (obj) {
					return this.labelMap(obj);
				}
			},
			clearMap: {
				type: Function,
				default: function (obj) {
					return obj;
				}
			},
			value: {
				type: [String, Number],
				default() {
					return {};
				}
			},
			clear: {

			},
			mutable: {
				type: Boolean,
				default: false
			},
			url: {
				type: String,
				required: true
			},
			map: {
				type: Function,
				default: function (obj) {
					
					return obj;
				}
			}
		},
		computed: {
			_valid() {
				return this.validator(this.value);
			},
			_actions() {
				var r = [];
				var self = this;	

				for (var i = 0; i < this.results.length; ++i) {
					var obj = self.map(self.results[i])	;

					

					r.push({
						label: self.descMap(obj),
						action: (function () {
							var obj = self.map(self.results[i])	;
							var completeObj = merge({}, self.results[i]);

							return function () {
								
								self.$emit('select', obj);
							}
						})()
					});
				}

				if (self.create) {
					r.push(null);
					r.push({
						label: 'Opret',
						action: function () {
							
						}
					});
				}

				return r;
			}
		},
		methods: {
			focus(e) {
				e.target.select();
			},
			tap(e) {
				
				this.$emit('input', e.target.value);

				this.$store.state.popupController.close();
				
				//this.$emit('input', merge(this.value, { label: this.str }));
				//this.$emit('lbl:update', this.str );

				var self = this;

				clearTimeout(this.timeout);

				this.timeout = setTimeout(function () {
					self.search();
				}, 500);
			},
			search() {
				if (this.value == '') return;

				

				var self = this;

				this.axios
					.get(this.url + '?search=' + encodeURI(this.value))
					.then(function (r) {
						self.results = r.data._items;

						var actions = self.results.length == 0 ? (self.create ? [
							{
								label: 'Opret',
								action: function () {
									
								}
							}
						] : []) : self._actions;

						self.$store.state.popupController.popup(ContextPopupView, {
							anchor: self.$refs.input,
							align: 'left',
							actions: actions
						});
					});
			}
		},
		async mounted() {
			/*if (this.validator(this.value)) {
				this.str = this.labelMap(this.value).toString();
			}*/

			
		}
	}
</script>

<style lang="scss" scoped>
	.entity-select-view {
		& > input {
			display: block;
			width: 100%;
			height: 100%;
			background-color: #202127;
			color: white;
		}

		& > .edit__label {
			position: relative;
			margin-bottom: 5px;
		}
	}
</style>